import { listOnboardingQueueOptions } from "@payezy/api-client/admin/query";
import { Badge, Card, EmptyState, formatDate, humanize, PageHeader, Tabs, Table, TD, TH, THead, TR } from "@payezy/ui";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { Link } from "@tanstack/react-router";
import { useState } from "react";
import { onboardingTone } from "../lib/staff";

export function OnboardingPage() {
  const [status, setStatus] = useState("in_review");
  const q = useQuery({ ...listOnboardingQueueOptions({ query: { status: status === "all" ? undefined : status, limit: 200 } }), placeholderData: keepPreviousData, refetchInterval: 30_000 });
  const items = q.data?.items ?? [];
  return (
    <>
      <PageHeader
        title="KYC / KYB queue"
        description="Verification decisions are made by the partner. Use this queue to follow up on stuck applications and document requests. Sensitive identifiers stay encrypted; only previews are shown."
      />
      <Tabs
        value={status}
        onValueChange={setStatus}
        tabs={["submitted", "in_review", "documents_required", "rejected", "approved", "all"].map((s) => ({ value: s, label: humanize(s) }))}
      />
      <Card>
        <Table>
          <THead><TR><TH>Applicant</TH><TH>Entity</TH><TH>State</TH><TH>Tax id</TH><TH>Status</TH><TH>Submitted</TH><TH>Updated</TH></TR></THead>
          <tbody>
            {items.map((a) => (
              <TR key={a.id} className="hover:bg-ink-50">
                <TD>
                  <Link to="/customers/$orgId" params={{ orgId: a.org_id }} className="font-medium hover:underline">{a.display_name || "Unnamed"}</Link>
                  {a.email && <p className="text-xs text-ink-500">{a.email}</p>}
                </TD>
                <TD>{humanize(a.entity_type)}{a.owners ? ` · ${a.owners} owner${a.owners > 1 ? "s" : ""}` : ""}</TD>
                <TD>{a.state ?? "—"}</TD>
                <TD className="font-mono text-xs">{a.tax_id_last4 ? `•••• ${a.tax_id_last4}` : "—"}</TD>
                <TD>
                  <Badge tone={onboardingTone[a.status]}>{humanize(a.status)}</Badge>
                  {a.required_documents > 0 && <span className="ml-2 text-xs text-ink-500">{a.required_documents} doc request{a.required_documents > 1 ? "s" : ""}</span>}
                </TD>
                <TD>{formatDate(a.submitted_at, true)}</TD>
                <TD>{formatDate(a.updated_at, true)}</TD>
              </TR>
            ))}
          </tbody>
        </Table>
        {!q.isLoading && items.length === 0 && <EmptyState title="Queue is empty" />}
      </Card>
    </>
  );
}
